import React from 'react'
import styled from 'styled-components'
import Container from './Container'
import Button from './Button'
import media from 'css-in-js-media'
import { StyledButton } from './ButtonStyled'
import { Variables } from '../styles/Variables'
import { FormattedMessage } from 'react-intl'

const PricelistSection = styled.div`
    .DesktopOnly {
        ${media('<desktop')} {
            display: none;
        }
    }
`

const PricelistTable = styled.table`
    width: 100%;
    font-size: 14px;
    line-height: 120%;
    text-align: center;
    letter-spacing: 0.001em;
    border-spacing: 0;

    ${StyledButton} {
        font-family: ${Variables.font.body} ;
        background: none;
        border: none;
        color: ${Variables.color.white};
        text-decoration: underline;
        font-size: 18px;
        line-height: 28px;
        font-weight: 400;
        text-transform: initial;
        &::before {
            display: none;
        }

        ${media('<desktop')} {
            width: 100%;
            font-size: 16px;
            line-height: 24px;
            padding: 0;
            height: 100%;
        }
    }
`

const PricelistTable_Header = styled.thead`    
    th {
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0.1em;
        color: ${Variables.color.white};
        text-transform: uppercase;
        border-bottom: 1px solid ${Variables.color.pazolaGold};
        padding-bottom: 42px;        
        text-align: center;

        ${media('<desktop')} {
            font-size: 12px;
            line-height: 130%;
            padding-bottom: 28px;
        }
    }
`

const PricelistTable_Row = styled.tr`
    td {
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        padding: 0;        
        font-family: ${Variables.font.body};
        color: ${Variables.color.white};
        border-bottom: 1px solid ${Variables.color.pazolaGold};
        ${media('<desktop')} {
            padding: 5px;
            font-size: 16px;
            line-height: 24px;
        }

        ${StyledButton} {
            letter-spacing: initial;
        }

        &.is-sold {
            color: ${Variables.color.white};
            position: relative;
            &::before {
                content: '';
                position: absolute;
                width: 100%;
                padding-bottom: 41px;
                top: 6px;
                left: 0;
                z-index: -1;
                background: ${Variables.color.pazolaGold};
            }
        }
    }   
`

export const Pricelist: React.FC<{
    data?: object
}> = ({ data }) => {
    const { items, pricelistPdf } = data
    return (
        <PricelistSection>
            <Container>
                <PricelistTable>
                    <PricelistTable_Header>
                        <tr>
                            <th><FormattedMessage id="Residence" /></th>
                            {/* <th><FormattedMessage id="Unit No." /></th> */}
                            <th className="DesktopOnly"><FormattedMessage id="Floor" /></th>
                            <th className="DesktopOnly"><FormattedMessage id="Bedrooms" /></th>
                            <th><FormattedMessage id="Size" /></th>
                            <th className="DesktopOnly"><FormattedMessage id="Balcony" /></th>
                            <th className="DesktopOnly"><FormattedMessage id="Availability" /></th>
                            <th><FormattedMessage id="Floorplans" /></th>
                            <th><FormattedMessage id="Price" /></th>
                        </tr>
                    </PricelistTable_Header>
                    <tbody>
                        {items &&
                            items.map((item, i) => (
                                <PricelistTable_Row key={i}>
                                    <td>{item.unit}</td>
                                    {/* <td className="DesktopOnly">{item.unitNo}</td> */}
                                    <td className="DesktopOnly">{item.floor}</td>
                                    <td className="DesktopOnly">{item.bedrooms}</td>
                                    <td>{item.sqMetres}</td>
                                    <td className="DesktopOnly">
                                        {item.balcony && ( <FormattedMessage id={item.balcony} /> )}
                                    </td>
                                    <td className={`DesktopOnly ${item.availability && (item.availability == 'Sold' || item.availability == 'Reserved') && "is-sold"}`}>
                                        {item.availability && (
                                            <FormattedMessage id={item.availability} />
                                        )}
                                    </td>
                                    <td>
                                        {item.floorplans && (
                                            <Button buttonLink={{ externalLink: item.floorplans.file.url }} linkstyle>
                                                <FormattedMessage id="Download" />                                                
                                            </Button>
                                        )}
                                    </td>
                                    <td>
                                        {pricelistPdf && (
                                            <Button buttonLink={{ externalLink: pricelistPdf.file.url }} linkstyle>
                                                <FormattedMessage id="Price list" />                                                
                                            </Button>
                                        )}
                                    </td>
                                </PricelistTable_Row>
                            ))}
                    </tbody>
                </PricelistTable>                
            </Container>
        </PricelistSection>
    )
}
export default Pricelist
